const brandMapping: { [key: string]: string } = {
  '#00D9C5': '#E4F9F1',
  '#F7F7F7': '#F1F1F7',
  '#ECFCF9': '#E4F9F1',
};

export default brandMapping;
